import React, { Component } from 'react';

import API from '../../utils/API';
import ViewsContainer from '../../components/views/ViewsContainer';
import LoadingWizard from '../../components/spinner/wizard';
import AddBookingModal from './modals/addBookingModal';
import DeleteBookingModal from './modals/deleteBookingModal';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

let batchCallback;
class Booking extends Component {
	constructor(props) {
		super(props);

		const fieldColumns = {
			name: 'Name',
			description: 'Description',
			meetingCount: 'Total Meetings',
			pendingMeetings: 'Pending Meetings',
			activeCalendars: 'Active Calendars',
			isActive: 'Status',
			bookingLink: 'Booking Link',
			lastBooking: 'Last Booking',
			createdByName: 'Created By',
			createdAt: 'Created At',
		};

		const fieldTypes = {
			name: 'string',
			description: 'string',
			meetingCount: 'number',
			pendingMeetings: 'number',
			activeCalendars: 'number',
			isActive: 'string',
			bookingLink: 'link',
			lastBooking: 'datetime',
			createdByName: 'string',
			createdAt: 'timestamp',
		};

		const fieldCategories = {
			basics: {
				title: 'Basics',
				columns: [
					'name',
					'description',
					'meetingCount',
					'pendingMeetings',
					'activeCalendars',
					'isActive',
					'bookingLink',
					'lastBooking',
					'createdByName',
					'createdAt',

				]
			},
		};
		this.state = {
			bookingPages: [],
			bookingViews: [],
			categoryColumns: fieldCategories,
			loading: true,
			columns: fieldColumns,
			columnTypes: fieldTypes,
			addedBookingPages: [],
			selectedBookingPages: [],
			addModalOpen: false,
			deleteModalOpen: false,
			meetings: [],
			latestMeetings: [
				{
					title: 'Team Consultation',
					customerName: 'John Doe', 
					scheduledTime: moment().add(2, 'days').toISOString()
				},
				{
					title: 'Strategy Session',
					customerName: 'Jane Smith',
					scheduledTime: moment().add(5, 'days').toISOString()
				}
			],
			meetingSummaryOpen: false,
			eventMap: {}
		};
	}

	componentDidMount() {
		 API()
		 	.get(`Organizations/${this.props.orgId}/bookingPages`)
		 	.then((res) => {
		 		if (res.data) {
		 			this.setState({
		 				bookingPages: res.data.bookingPages.map(bp => {
		 					return {
		 						...bp,
		 						link: `/${this.props.orgId}/booking/${bp._id}/form`
		 					}
		 				}),
		 				bookingViews: res.data.views,
		 				loading: false
		 			});
		 		} else {
		 			this.setState({
		 				loading: false
		 			});
		 		}
		 	})
		 	.catch((e) => {
		 		console.log(e);
		 		this.setState({ loading: false });
		 	});

			API().get(`Organizations/${this.props.orgId}/eventNames`)
				.then((res) => {
					if (res.data) {
						const eventMap = {};
						res.data.events.forEach(event => {
							eventMap[event._id] = event;
						});
						this.setState({
							eventMap: eventMap,
							loading: false
						});
					} else {
						this.setState({
							loading: false
						});
					}
				})
				.catch((e) => {
					console.log(e);
					this.setState({ loading: false });
				});
	}

	toggleAdd = () => {
		this.setState({ addModalOpen: !this.state.addModalOpen });
	};

	addBookingPage = async (bookingPage) => {
		// Keep the API call for future backend integration
		await API()
			.post(`Organizations/${this.props.orgId}/bookingPages`, bookingPage)
			.then((res) => {
				if (res.data) {
					const newBookingPage = {
						...res.data,
						bookingLink: `${window.location.origin}/${this.props.orgId}/book/${res.data._id}`,
					};
					this.setState({ bookingPages: [...this.state.bookingPages, newBookingPage], adding: false });
					this.props.history.push(`/${this.props.orgId}/booking/${res.data._id}/form`);
					return true;
				} else {
					return false;
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	toggleDeleteBookingPages = (bookingPageIds, bcb) => {
		batchCallback = bcb;
		this.setState({
			selectedBookingPages: bookingPageIds ? Object.keys(bookingPageIds) : [],
			deleteModalOpen: !this.state.deleteModalOpen
		});
	};

	deleteBookingPages = async () => {
		await API()
		.post(`Organizations/${this.props.orgId}/bookingPages/delete`, { bookingIds: this.state.selectedBookingPages })
		.then((res) => {
			if (res.data) {
				const bookingPages = this.state.bookingPages.filter((bp) => !this.state.selectedBookingPages.includes(bp._id));
				this.setState({ bookingPages: bookingPages });
				batchCallback && batchCallback('delete');
				this.toggleDeleteBookingPages({});
			}
		});
	};

	render() {
		const {
			loading,
			bookingViews,
			columns,
			bookingPages,
			columnTypes,
			addModalOpen,
			addedBookingPages,
			deleteModalOpen,
			categoryColumns,
			latestMeetings
		} = this.state;

		return (
			<div 
				className="pageContainer" 
			>
					{!loading && (
						<ViewsContainer
							views={bookingViews}
							entries={bookingPages}
							columns={columns}
							columnTypes={columnTypes}
							categoryColumns={categoryColumns}
							title="Booking Pages"
							readOnly={false}
							mainActions={[{ 
								type: 'button', 
								onClick: this.toggleAdd, 
								label: 'Create Booking Page',
								style: {
									background: 'linear-gradient(45deg, #4facfe 0%, #00f2fe 100%)',
									border: 'none',
									borderRadius: '25px',
									padding: '12px 24px',
									color: 'white',
									fontWeight: '600',
									boxShadow: '0 4px 15px rgba(79, 172, 254, 0.4)',
									transition: 'all 0.3s ease'
								}
							}]}
							batchActions={[
								{
									label: 'Delete',
									iconClass: 'las la-trash-alt',
									class: 'danger',
									onClick: this.toggleDeleteBookingPages,
									style: {
										background: 'linear-gradient(45deg, #ff6b6b, #ee5a52)',
										border: 'none',
										borderRadius: '20px',
										color: 'white'
									}
								}
							]}
							columnWidths={{
								meetingCount: 150,
								pendingMeetings: 150,
								activeCalendars: 150
							}}
							enableDownloadViews={true}
							orgId={this.props.orgId}
							type={'BookingPage'}
							referenceCollection={'Organizations'}
							referenceId={this.props.orgId}
							addedEntries={addedBookingPages}
							description="Create beautiful booking pages to allow customers to schedule meetings and consultations directly."
							summaryPanel={
								<div 
									className='summaryPanel' 
									style={{
										background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
										borderRadius: '15px',
										color: 'white',
										padding: '20px',
										cursor: 'pointer',
										transition: 'transform 0.3s ease',
									}}
									onClick={() => this.setState({ meetingSummaryOpen: true })}
									onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
									onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
								>
									<div className='flex aic jcsb mb-10 w-100'>
										<h5 className='mr-25' style={{ color: 'white', margin: 0 }}>
											<i className='las la-calendar-check mr-10'></i>
											{latestMeetings.length} Recent Bookings
										</h5>
										<i className='las la-angle-right' style={{ color: 'white' }}></i>
									</div>
									<div className='flex column wrap jcfe'>
										{latestMeetings.length > 0 ? latestMeetings.map((meeting, i) => {
											if (i < 2) {
												return (
													<div key={i} className='flex aic' style={{ marginBottom: i < 1 ? 5 : 0 }}>
														<h4 className='mr-5' style={{ color: 'rgba(255,255,255,0.9)', fontSize: '14px', margin: 0 }}>
															{meeting.title} - {meeting.customerName} scheduled for
														</h4>
														<h3 style={{ color: 'white', fontSize: '14px', margin: 0 }}>
															{moment(meeting.scheduledTime).format('MMM D, h:mm A')}
														</h3>
													</div>
												);
											}
											return null;
										}) : <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0 }}>No recent bookings</p>}
									</div>
								</div>
							}
						/>
					)}
				
				<LoadingWizard text="Loading Booking Pages" loading={loading} />
				
				{addModalOpen && (
					<AddBookingModal
						isOpen={addModalOpen}
						toggle={() => this.setState({ addModalOpen: false })}
						handleSubmit={this.addBookingPage}
						organization={this.props.organization}
						eventMap={this.state.eventMap}
					/>
				)}
				
				{deleteModalOpen && (
					<DeleteBookingModal
						isOpen={deleteModalOpen}
						toggle={this.toggleDeleteBookingPages}
						delete={this.deleteBookingPages}
						count={this.state.selectedBookingPages.length}
					/>
				)}
			</div>
		);
	}
}

export default withRouter(Booking);
